import { render, staticRenderFns } from "./ProjectEventsCard.vue?vue&type=template&id=5419bbd2"
import script from "./ProjectEventsCard.vue?vue&type=script&lang=js"
export * from "./ProjectEventsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports